import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { CloseAccountState } from 'features/CloseAccount/types/CloseAccountState.types'

interface CloseAccountLocationState {
  CloseAccountModal?: CloseAccountState
}

export const useCloseAccountState = () => {
  const location = useLocation<CloseAccountLocationState | undefined>()

  const state = useMemo(() => {
    if (!location.state?.CloseAccountModal?.accountId) {
      return null
    }

    return location.state.CloseAccountModal
  }, [location.state?.CloseAccountModal])

  return { state }
}
